/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessSourceStat } from './BusinessSourceStat';
import {
    BusinessSourceStatFromJSON,
    BusinessSourceStatFromJSONTyped,
    BusinessSourceStatToJSON,
    BusinessSourceStatToJSONTyped,
} from './BusinessSourceStat';
import type { OrderStatisticsWarehouseOption } from './OrderStatisticsWarehouseOption';
import {
    OrderStatisticsWarehouseOptionFromJSON,
    OrderStatisticsWarehouseOptionFromJSONTyped,
    OrderStatisticsWarehouseOptionToJSON,
    OrderStatisticsWarehouseOptionToJSONTyped,
} from './OrderStatisticsWarehouseOption';
import type { TrendData } from './TrendData';
import {
    TrendDataFromJSON,
    TrendDataFromJSONTyped,
    TrendDataToJSON,
    TrendDataToJSONTyped,
} from './TrendData';
import type { KpiCards } from './KpiCards';
import {
    KpiCardsFromJSON,
    KpiCardsFromJSONTyped,
    KpiCardsToJSON,
    KpiCardsToJSONTyped,
} from './KpiCards';
import type { BusinessTypeStat } from './BusinessTypeStat';
import {
    BusinessTypeStatFromJSON,
    BusinessTypeStatFromJSONTyped,
    BusinessTypeStatToJSON,
    BusinessTypeStatToJSONTyped,
} from './BusinessTypeStat';
import type { MonthlyBusinessSource } from './MonthlyBusinessSource';
import {
    MonthlyBusinessSourceFromJSON,
    MonthlyBusinessSourceFromJSONTyped,
    MonthlyBusinessSourceToJSON,
    MonthlyBusinessSourceToJSONTyped,
} from './MonthlyBusinessSource';
import type { MonthlyBusinessStructure } from './MonthlyBusinessStructure';
import {
    MonthlyBusinessStructureFromJSON,
    MonthlyBusinessStructureFromJSONTyped,
    MonthlyBusinessStructureToJSON,
    MonthlyBusinessStructureToJSONTyped,
} from './MonthlyBusinessStructure';

/**
 * 
 * @export
 * @interface OrderStatisticsRespVo
 */
export interface OrderStatisticsRespVo {
    /**
     * 可选年份列表（当前年份前5年）
     * @type {Array<number>}
     * @memberof OrderStatisticsRespVo
     */
    yearOptions?: Array<number>;
    /**
     * 可选仓库列表（中韩仓库）
     * @type {Array<OrderStatisticsWarehouseOption>}
     * @memberof OrderStatisticsRespVo
     */
    warehouseOptions?: Array<OrderStatisticsWarehouseOption>;
    /**
     * 
     * @type {KpiCards}
     * @memberof OrderStatisticsRespVo
     */
    kpiCards?: KpiCards;
    /**
     * 
     * @type {TrendData}
     * @memberof OrderStatisticsRespVo
     */
    trendData?: TrendData;
    /**
     * 业务结构年度汇总
     * @type {Array<BusinessTypeStat>}
     * @memberof OrderStatisticsRespVo
     */
    businessStructureAnnual?: Array<BusinessTypeStat>;
    /**
     * 业务结构月度详情
     * @type {Array<MonthlyBusinessStructure>}
     * @memberof OrderStatisticsRespVo
     */
    businessStructureMonthly?: Array<MonthlyBusinessStructure>;
    /**
     * 业务来源分析年度汇总（代买/转运）
     * @type {Array<BusinessSourceStat>}
     * @memberof OrderStatisticsRespVo
     */
    businessSourceAnnual?: Array<BusinessSourceStat>;
    /**
     * 业务来源分析月度详情（代买/转运）
     * @type {Array<MonthlyBusinessSource>}
     * @memberof OrderStatisticsRespVo
     */
    businessSourceMonthly?: Array<MonthlyBusinessSource>;
}

/**
 * Check if a given object implements the OrderStatisticsRespVo interface.
 */
export function instanceOfOrderStatisticsRespVo(value: object): value is OrderStatisticsRespVo {
    return true;
}

export function OrderStatisticsRespVoFromJSON(json: any): OrderStatisticsRespVo {
    return OrderStatisticsRespVoFromJSONTyped(json, false);
}

export function OrderStatisticsRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderStatisticsRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'yearOptions': json['yearOptions'] == null ? undefined : json['yearOptions'],
        'warehouseOptions': json['warehouseOptions'] == null ? undefined : ((json['warehouseOptions'] as Array<any>).map(OrderStatisticsWarehouseOptionFromJSON)),
        'kpiCards': json['kpiCards'] == null ? undefined : KpiCardsFromJSON(json['kpiCards']),
        'trendData': json['trendData'] == null ? undefined : TrendDataFromJSON(json['trendData']),
        'businessStructureAnnual': json['businessStructureAnnual'] == null ? undefined : ((json['businessStructureAnnual'] as Array<any>).map(BusinessTypeStatFromJSON)),
        'businessStructureMonthly': json['businessStructureMonthly'] == null ? undefined : ((json['businessStructureMonthly'] as Array<any>).map(MonthlyBusinessStructureFromJSON)),
        'businessSourceAnnual': json['businessSourceAnnual'] == null ? undefined : ((json['businessSourceAnnual'] as Array<any>).map(BusinessSourceStatFromJSON)),
        'businessSourceMonthly': json['businessSourceMonthly'] == null ? undefined : ((json['businessSourceMonthly'] as Array<any>).map(MonthlyBusinessSourceFromJSON)),
    };
}

export function OrderStatisticsRespVoToJSON(json: any): OrderStatisticsRespVo {
    return OrderStatisticsRespVoToJSONTyped(json, false);
}

export function OrderStatisticsRespVoToJSONTyped(value?: OrderStatisticsRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'yearOptions': value['yearOptions'],
        'warehouseOptions': value['warehouseOptions'] == null ? undefined : ((value['warehouseOptions'] as Array<any>).map(OrderStatisticsWarehouseOptionToJSON)),
        'kpiCards': KpiCardsToJSON(value['kpiCards']),
        'trendData': TrendDataToJSON(value['trendData']),
        'businessStructureAnnual': value['businessStructureAnnual'] == null ? undefined : ((value['businessStructureAnnual'] as Array<any>).map(BusinessTypeStatToJSON)),
        'businessStructureMonthly': value['businessStructureMonthly'] == null ? undefined : ((value['businessStructureMonthly'] as Array<any>).map(MonthlyBusinessStructureToJSON)),
        'businessSourceAnnual': value['businessSourceAnnual'] == null ? undefined : ((value['businessSourceAnnual'] as Array<any>).map(BusinessSourceStatToJSON)),
        'businessSourceMonthly': value['businessSourceMonthly'] == null ? undefined : ((value['businessSourceMonthly'] as Array<any>).map(MonthlyBusinessSourceToJSON)),
    };
}

